import React from 'react';

import {
    Button,
    ButtonVariant,
    Modal,
    ModalBody,
    ModalFooter,
    Spacer,
    SpacerSize,
    Text,
    TypographyBold,
} from '@bytel/trilogy-react';

import { getAppConfig } from '@services/config';

import { Big } from '@components/big';

type PromoHomeModalProps = {
    isOpen: boolean;
    onClose: () => void;
};

const appConfig = getAppConfig();

export function PromoHomeModal({ isOpen = false, onClose }: Readonly<PromoHomeModalProps>) {
    return (
        <Modal active={isOpen} onClose={onClose} title='Je suis déjà client Bbox'>
            <ModalBody>
                <Text typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD}>
                    Avec <Big />, le nouveau pack Bbox + forfaits mobile, faites de <Big /> économies.
                </Text>
                <Text>Grâce à votre Bbox, le prix de chacun de vos forfaits baisse.</Text>
                <Spacer size={SpacerSize.FOUR} />
                <div className='is-flex is-justified-center'>
                    <img
                        loading='lazy'
                        src={`${appConfig.assets.cmsImages.url}/forfaits/infographie-offres-big.webp`}
                        alt='Infographie montrant des économies mensuelles liées à l’ajout de forfaits Bouygues Telecom avec une Bbox. Pour un forfait : 5 € d’économies par mois, pour deux forfaits : 16 € d’économies par mois, et pour trois forfaits : 30 € d’économies par mois. Voir conditions sur bouyguestelecom.fr.'
                        width={320}
                    />
                </div>
            </ModalBody>
            <ModalFooter>
                <Button variant={ButtonVariant.SECONDARY} onClick={onClose}>
                    Fermer
                </Button>
            </ModalFooter>
        </Modal>
    );
}
